import { usePersonRepoStore } from '../store/personRepoStore';

function getQuestionResponse(question: any) {
  const qnDetails = usePersonRepoStore.getState().question;

  let responses: any = [];
  responses =
    question?.PersonAssociation === 0
      ? qnDetails?.CallerResponses
      : question?.PersonAssociation === 1
      ? qnDetails?.PersonOfConcernResponses
      : [];
  const defaultValue = responses?.find(
    (response: any) =>
      response.QuestionTemplateId === question?.QuestionTemplateId,
  );
  if (defaultValue === undefined) return '';
  else return defaultValue;
}

export function getSavedResponses(questions: Array<any>) {
  const responses: any = {};
  questions?.forEach(question => {
    const qnTempId = question.QuestionTemplateId;
    switch (question?.QuestionTemplate?.QuestionType?.KnockoutComponent) {
      case 'dob':
        const dobResp = getQuestionResponse(question);
        dobResp !== undefined
          ? (responses.Dob = {
              ...responses.Dob,
              [qnTempId]:
                dobResp && dobResp?.Value ? JSON.parse(dobResp?.Value) : '',
            })
          : null;
        break;
      case 'dob-comments':
        const dobCommentsResp = getQuestionResponse(question);
        dobCommentsResp !== undefined
          ? (responses.DobComments = {
              ...responses.DobComments,
              [qnTempId]:
                dobCommentsResp && dobCommentsResp?.Value
                  ? JSON.parse(dobCommentsResp?.Value)
                  : '',
            })
          : null;
        break;

      case 'date':
        const dateResp = getQuestionResponse(question);
        dateResp !== undefined
          ? (responses.Date = {
              ...responses.Date,
              [qnTempId]: dateResp ? dateResp?.Value : '',
            })
          : null;
        break;

      case 'address':
        const addressVal = getQuestionResponse(question);
        addressVal !== undefined
          ? (responses.Address = {
              ...responses.Address,
              [qnTempId]:
                addressVal && addressVal?.Value
                  ? JSON.parse(addressVal?.Value)
                  : '',
            })
          : null;
        break;

      case 'choice':
        const choiceVal = getQuestionResponse(question);
        choiceVal !== undefined
          ? (responses.Choice = {
              ...responses.Choice,
              [qnTempId]: choiceVal?.Value ? choiceVal?.Value?.split('|') : [],
            })
          : null;
        break;
      case 'lookup':
        const lookupVal = getQuestionResponse(question);
        lookupVal !== undefined
          ? (responses.Lookup = {
              ...responses.Lookup,
              [qnTempId]: lookupVal?.Value ? JSON.parse(lookupVal?.Value) : [],
            })
          : null;
        break;
      case 'text':
        const textVal = getQuestionResponse(question);
        textVal !== undefined
          ? (responses.TextView = {
              ...responses.TextView,
              [qnTempId]: textVal?.Value ? textVal?.Value : '',
            })
          : null;
        break;
    }
  });
  return responses;
}
